import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faCircleQuestion, faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { HttpClient } from '@angular/common/http';

import { SystemMessage } from '../../core/system-message/system-message-service';
import { NotificationService } from '../../services/notification.service';
import { UserJsVm } from '../generated/Admin/Models/User/UserJsVm';

@Component({
    selector: 'pcg-skip-seal-popup',
    standalone: false,
    templateUrl: './skip-seal-popup.component.html',
    styleUrl: './skip-seal-popup.component.scss',
})
export class SkipSealPopupComponent {

    public activeModal = inject(NgbActiveModal);
    public httpClient = inject(HttpClient);
    public ns = inject(NotificationService);

    dontRemindAgain = false;
    faIconName = { 
        faCircleQuestion
        , faArrowUpRightFromSquare 
    };

    ngOnInit() {}

    onGotItClick() {
        if (this.dontRemindAgain) {
            this.httpClient.post<SystemMessage>(`api/Admin/Users/DisableSkipSealPopup`, {})
                .subscribe((sm: SystemMessage) => {
                    if (sm.isSuccessful) { 
                        let user: UserJsVm | null = JSON.parse(localStorage.getItem("user") || 'null');
                        if (user) {
                            user.isSkipSealPopupDisabled = true;
                            localStorage.setItem('user', JSON.stringify(user));
                        }
                        this.activeModal.close(); 
                    }
                    else { this.ns.showError(sm?.message, {timeOut: 5000}); }
                });
        } else { this.activeModal.close(); } 
    }
}
